export default __webpack_public_path__ + "assets/images/Payment_04.a26e86.png";